var EHDI = EHDI || Object.create(null);

// onInit function
function GameInit(gameType, gameElement, gameLevelComplete, gameEndFunction, gameData, pracPlay, htpShow, previousScore) {

    // Not needed anymore since game will be standalone
    // EHDI.urlParams = {type : "sepa"}

    // Initialize constants
    EHDI.GAME.constants = EHDI.GAME.constants || Object.create(null);
    Object.defineProperties(EHDI.GAME.constants,
        {
            'boundHeight': { value: 600 },
            'boundWidth': { value: 1024 },
            'gameType': { value: gameType },
            'gameData': { value: gameData },
            'previousScore': { value: previousScore },
            'pracPlay': { value: pracPlay },
            'gameEndFunction': { value: gameEndFunction },
            'gameLevelComplete': { value: gameLevelComplete },
            'htpShow': { value: htpShow },
            'gametimelimit': { value: 60000 },
            'gameinitspeed': { value: 0.1875 },//0.375},
            'gamefinalspeed': { value: 1 },
            'spawndelay': { value: 300 },
        }
    );

    // Initialize scene manager instance
    EHDI.GAME.sceneManager = EHDI.SceneManager(EHDI.GAME.constants.boundWidth, EHDI.GAME.constants.boundHeight);
    //EHDI.GAME.scaleManager = EHDI.ScaleManager(EHDI.GAME.sceneManager.getRenderer(), EHDI.GAME.sceneManager.getStage(), EHDI.ScaleManager.DOCKING.AUTO, EHDI.GAME.sceneManager.defaultWidth, EHDI.GAME.sceneManager.defaultHeight);
    //EHDI.GAME.scaleManager.addAutomaticScaling();

    // Call resize method
    EHDI.onResize();

    // Initialize storage manager
    EHDI.GAME.storageManager = EHDI.StorageManager();

    // Initialize update manager
    EHDI.GAME.updateManager = EHDI.UpdateManager(EHDI.GAME.sceneManager.getRenderer(), EHDI.GAME.sceneManager.getStage());

    // Initialize sound manager
    EHDI.GAME.soundManager = EHDI.SoundManager(true);

    // Initialize storage manager
    EHDI.GAME.saveData = EHDI.GAME.storageManager.getLocalInfo(EHDI.GAME.id) || { highScore: 0, isFirstTimePlay: true, isMuted: false };
    EHDI.GAME.storageManager.setLocalInfo(EHDI.GAME.id, EHDI.GAME.saveData);

    // Set sound manager default mute state
    EHDI.GAME.soundManager.setMute(EHDI.GAME.saveData.isMuted);

    EHDI.LoadManager.queueAssets(AssetDirectory.preload);

    var promises = [];
    this.fontObserve = [];
    for (var i = 0; i < EHDI.Assets.fonts.length; i++) {
        this.fontObserve[i] = new FontFaceObserver(EHDI.Assets.fonts[i]);
        promises.push(this.fontObserve[i].load(null, 8000));
    }
    Promise.all(promises)
        .then(function () {
            EHDI.LoadManager.start(EHDI.loadScene);
        });

    if (PIXI.VERSION[0] == '5') {
        // Set canvas to Main ajdnput on div
        EHDI.canvas = EHDI.GAME.sceneManager.getRenderer().view;
        EHDI.canvas.id = "game-canvas";
        EHDI.canvas.width = EHDI.vendorGameElement.style.width;
        EHDI.canvas.height = EHDI.vendorGameElement.style.height;
        EHDI.vendorGameElement.appendChild(EHDI.canvas);
    }

    // console.log(AssetDirectory.preload);
    // EHDI.LoadManager.queueStrings(AssetDirectory.preloadString)
    /* var showLoadScene = function(){
        EHDI.LoadManager.queueAssets(AssetDirectory.preload);

        var promises = [];
        this.fontObserve = [];
        for(var i = 0; i < EHDI.Assets.fonts.length;i++){
            this.fontObserve[i] = new FontFaceObserver(EHDI.Assets.fonts[i]);
            promises.push(this.fontObserve[i].load(null,8000));
        }
        Promise.all(promises)
            .then(function(){
        EHDI.LoadManager.start(EHDI.loadScene);
        });
    } */

    /* EHDI.sbGame.loadGameData(undefined,
        //LOAD DATA SUCCESS
        function(data){
            EHDI.GAME.saveData = (typeof data === 'object') ? data : {highScore: 0, isFirstTimePlay: true};
            showLoadScene();
        },
        //LOAD DATA FAILED
        function(){
            EHDI.GAME.saveData = {highScore: 0, isFirstTimePlay: true};
            showLoadScene();
        }
    ) */

    EHDI.restart = function () {
        if (EHDI.GAME.gameObject) {
            EHDI.GAME.gameObject.replay();
        }
    }

    EHDI.destroy = function () {
        EHDI.GAME.soundManager.stopBGM();

        if (EHDI.GAME.gameObject) {
            EHDI.GAME.gameObject.dispose();
        }
        if (EHDI.scene.TitleScene.prototype) {
            EHDI.scene.TitleScene.prototype.dispose();
        }

        EHDI.vendorGameElement.removeChild(EHDI.canvas);
        document.body.removeChild(EHDI.vendorGameElement);

        EHDI.GAME.updateManager.removeAllFrameListeners();
        EHDI.GAME.updateManager.deleteUpdateManager();

        if (EHDI.GAME.scaleManager) EHDI.GAME.scaleManager.destroy();
        if (EHDI.GAME.sceneManager) EHDI.GAME.sceneManager.destroy();

    }
}

// onResize function 
EHDI.onResize = function () {
    if (!EHDI.canvas) return;
    // New code from MC
    EHDI.vendorGameElement.style.width = Math.min(document.documentElement.clientWidth, window.innerWidth || 0);
    EHDI.vendorGameElement.style.height = Math.min(document.documentElement.clientHeight, window.innerHeight || 0);
    // End new code

    // Initialize needed values
    var _width = EHDI.GAME.sceneManager.defaultWidth,
        _height = EHDI.GAME.sceneManager.defaultHeight,
        _scaleX = EHDI.vendorGameElement.offsetWidth / EHDI.GAME.sceneManager.defaultWidth,
        _scaleY = EHDI.vendorGameElement.offsetHeight / EHDI.GAME.sceneManager.defaultHeight,
        _ratio = Math.min(_scaleX, _scaleY);

    // Compute width and height
    _width = Math.ceil(_width * _ratio);
    _height = Math.ceil(_height * _ratio);

    // Set stage scale
    var stage = EHDI.GAME.sceneManager.getStage();
    stage.scale.x = stage.scale.y = _ratio;

    // Resize renderer
    EHDI.GAME.sceneManager.getRenderer().resize(_width, _height);

    // Set canvas properties
    EHDI.canvas.style.paddingLeft = 0;
    EHDI.canvas.style.paddingRight = 0;
    EHDI.canvas.style.paddingTop = 0;
    EHDI.canvas.style.paddingBottom = 0;
    EHDI.canvas.style.display = "block";
    EHDI.canvas.style.position = "absolute";
    EHDI.canvas.style.top = 0;
    EHDI.canvas.style.left = 0;
    EHDI.canvas.style.right = 0;
    EHDI.canvas.style.bottom = 0;

    // Adjust margins according to the following
    var _margin;
    if (_width < EHDI.vendorGameElement.offsetWidth) {

        // Compute margin
        _margin = (EHDI.vendorGameElement.offsetWidth - _width) / 2;

        // Set left and right margins
        EHDI.canvas.style.left = _margin + "px";
        EHDI.canvas.style.right = _margin + "px";
    }

    // 
    if (_height < EHDI.vendorGameElement.offsetHeight) {

        // Compute margin
        _margin = (EHDI.vendorGameElement.offsetHeight - _height) / 2;

        // Set top and bottom margins
        EHDI.canvas.style.top = _margin + "px";
        EHDI.canvas.style.bottom = _margin + "px";
    }

    // Scroll to 0, 0
    window.scrollTo(0, 0);
}

// onLoad function
EHDI.onWindowLoad = function () {

    //This will hold all global variables for the game as property
    EHDI.GAME = EHDI.GAME || Object.create(null);
    EHDI.GAME.language = "en";
    EHDI.GAME.id = gameId; //'13062756';

    // Create div element
    EHDI.vendorGameElement = document.createElement("div");
    EHDI.vendorGameElement.style.width = window.innerWidth;
    EHDI.vendorGameElement.style.height = window.innerHeight;
    EHDI.vendorGameElement.style.backgroundColor = '#0c3f76';
    document.body.appendChild(EHDI.vendorGameElement);

    if (PIXI.VERSION[0] == '4') {
        // Set canvas to Main ajdnput on div
        EHDI.canvas = document.createElement("canvas");
        EHDI.canvas.id = "game-canvas";
        EHDI.canvas.width = EHDI.vendorGameElement.style.width;
        EHDI.canvas.height = EHDI.vendorGameElement.style.height;
        EHDI.vendorGameElement.appendChild(EHDI.canvas);
    }

    EHDI.gameInit = new GameInit("full", EHDI.vendorGameElement, function () { console.log("Level Complete") }, null, null, true, true, true);

    // Add resize listener
    window.addEventListener("resize", EHDI.onResize);
}

// Prevent default on window touch move
/*
document.ontouchmove = function (e) {
    e.preventDefault();
    window.scrollTo(0, 0);
}*/

// Set on load function
window.onload = EHDI.onWindowLoad;